import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import { ExternalLink } from "../../../components/ExternalLink";
import { useCustomerChasables } from "../../../hooks/useCustomerChasables";
import Loading from "../ChaseInvoices/ChaseInvoicesLoading";
import { Empty } from "../../../components/Empty";
import { ChaseGroupedInvoicesContent } from "./ChaseGroupedInvoicesContent";
import { CustomerChaseSummaryModel } from "@attelas/shared";
import { CustomerInsights } from "../SuggestedChasable/CustomerInsights/CustomerInsights";
import { useCustomer } from "../../../hooks/useCustomer";
import { useTaskpaneTelemetry } from "../../../telemetry/useTaskpaneTelemetry";

type Props = {
  customerId: string;
  groupId: string;
  navigateToNextChasable: () => void;
  navigateToPreviousChasable: () => void;
};

const ChaseGroupedInvoices: React.FC<Props> = ({
  customerId,
  groupId,
  navigateToNextChasable,
  navigateToPreviousChasable,
}) => {
  const { trackReceivableGroupedChaseViewed } = useTaskpaneTelemetry();
  const { chasables, isLoading, isError } = useCustomerChasables(customerId);
  const { customer } = useCustomer(customerId);

  const groupedInvoices = React.useMemo(() => {
    const filteredInvoices = chasables?.invoices.filter((invoice) => invoice.groupId === groupId);
    return {
      ...chasables,
      invoices: filteredInvoices ?? [],
    } as CustomerChaseSummaryModel;
  }, [chasables, groupId]);

  React.useEffect(() => {
    if (!groupedInvoices?.invoices.length) return;
    trackReceivableGroupedChaseViewed({ invoice_count: String(groupedInvoices.invoices.length) });
  }, [groupedInvoices?.invoices.length, trackReceivableGroupedChaseViewed]);

  if (isLoading || isError) {
    return <Loading />;
  }

  if (!groupedInvoices?.invoices.length || !customer) {
    return <Empty text="No chasable found" />;
  }

  return (
    <>
      <Stack spacing={2} pb={12}>
        <Box>
          <ChaseGroupedInvoicesContent
            customerId={customerId}
            chasables={groupedInvoices}
            title="Chase Grouped Invoices"
            onSkip={navigateToNextChasable}
            onPrevious={navigateToPreviousChasable}
            groupedInvoices={true}
          />

          <CustomerInsights customerDetails={customer} />
        </Box>
      </Stack>
    </>
  );
};
export default ChaseGroupedInvoices;
